import React, { useState, useEffect, useRef } from 'react'
import { createUseStyles } from 'react-jss'
import { useBoolean } from '@rothzerg/useboolean'
import { isEmail, isEmpty } from '@rothzerg/validator'
import axios from 'axios'

import FormInput from '../ui/Form/FormInput'
import FormSelect from '../ui/Form/FormSelect'
import SVG from '../ui/SVG/SVG'
import FormCheckbox from '../ui/Form/FormCheckbox'
import Gtm from '../../utils/gtm'
import { loggingEnabled } from '../../utils/logging'

const parseXml = (xml, arrayTags) => {
  let dom = null
  if (window.DOMParser) dom = new DOMParser().parseFromString(xml, 'text/xml')
  else if (window.ActiveXObject) {
    dom = new ActiveXObject('Microsoft.XMLDOM')
    dom.async = false
    if (!dom.loadXML(xml)) throw dom.parseError.reason + ' ' + dom.parseError.srcText
  } else throw new Error('cannot parse xml string!')

  function parseNode(xmlNode, result) {
    if (xmlNode.nodeName == '#text') {
      let v = xmlNode.nodeValue
      if (v.trim()) result['#text'] = v
      return
    }

    let jsonNode = {},
      existing = result[xmlNode.nodeName]
    if (existing) {
      if (!Array.isArray(existing)) result[xmlNode.nodeName] = [existing, jsonNode]
      else result[xmlNode.nodeName].push(jsonNode)
    } else {
      if (arrayTags && arrayTags.indexOf(xmlNode.nodeName) != -1)
        result[xmlNode.nodeName] = [jsonNode]
      else result[xmlNode.nodeName] = jsonNode
    }

    if (xmlNode.attributes)
      for (let attribute of xmlNode.attributes) jsonNode[attribute.nodeName] = attribute.nodeValue

    for (let node of xmlNode.childNodes) parseNode(node, jsonNode)
  }

  let result = {}
  for (let node of dom.childNodes) parseNode(node, result)

  return result
}

const BlueChipForm = props => {
  const { body, center, ...rest } = props
  const gtm = new Gtm(loggingEnabled)

  const centerIt = center === '1'

  const [siteCountry, setSiteCountry] = useState('nz')
  const [countrylist, setcountrylist] = useState([])
  const [membershipNumber, setMembershipNumber] = useState('')

  const [formerror, setformerror] = useState([])

  const [formSubmitting, setFormSubmitting] = useBoolean()
  const [sameas, setsameas] = useBoolean()
  const [marketingemail, setmarketingemail] = useBoolean()
  const [marketingemailError, setmarketingemailError] = useState(undefined)

  const [termsandconditions, settermsandconditions] = useBoolean()
  const [termsandconditionsError, settermsandconditionsError] = useState(undefined)

  const [name, setname] = useState('')
  const [nameError, setnameError] = useState(undefined)

  const [middlename, setmiddlename] = useState('')
  const [middlenameError, setmiddlenameError] = useState(undefined)

  const [lastname, setlastname] = useState('')
  const [lastnameError, setlastnameError] = useState(undefined)

  const [dob, setdob] = useState('')
  const [dobError, setdobError] = useState(undefined)

  const [addressone, setaddressone] = useState('')
  const [addressoneError, setaddressoneError] = useState(undefined)

  const [addresstwo, setaddresstwo] = useState('')
  const [addresstwoError, setaddresstwoError] = useState(undefined)

  const [city, setcity] = useState('')
  const [cityError, setcityError] = useState(undefined)

  const [state, setstate] = useState('')
  const [stateError, setstateError] = useState(undefined)

  const [postcode, setpostcode] = useState('')
  const [postcodeError, setpostcodeError] = useState(undefined)

  const [country, setcountry] = useState('')
  const [countryError, setcountryError] = useState(undefined)

  const [billingaddressone, setbillingaddressone] = useState('')
  const [billingaddressoneError, setbillingaddressoneError] = useState(undefined)

  const [billingaddresstwo, setbillingaddresstwo] = useState('')
  const [billingaddresstwoError, setbillingaddresstwoError] = useState(undefined)

  const [billingcity, setbillingcity] = useState('')
  const [billingcityError, setbillingcityError] = useState(undefined)

  const [billingpostcode, setbillingpostcode] = useState('')
  const [billingpostcodeError, setbillingpostcodeError] = useState(undefined)

  const [billingstate, setbillingstate] = useState('')
  const [billingstateError, setbillingstateError] = useState(undefined)

  const [billingcountries, setbillingcountries] = useState('')
  const [billingcountriesError, setbillingcountriesError] = useState(undefined)

  const [homephone, sethomephone] = useState('')
  const [homephoneError, sethomephoneError] = useState(undefined)

  const [mobile, setmobile] = useState('')
  const [mobileError, setmobileError] = useState(undefined)

  const [email, setemail] = useState('')
  const [emailError, setemailError] = useState(undefined)

  const [confirmemail, setconfirmemail] = useState('')
  const [confirmemailError, setconfirmemailError] = useState(undefined)

  const [driverlicenseloc, setdriverlicenseloc] = useState('')
  const [driverlicenselocError, setdriverlicenselocError] = useState(undefined)

  const [driverlicensenum, setdriverlicensenum] = useState('')
  const [driverlicensenumError, setdriverlicensenumError] = useState(undefined)

  const [expdate, setexpdate] = useState('')
  const [expdateError, setexpdateError] = useState(undefined)

  const [promoCode, setPromoCode] = useState('')
  const [promoCodeError, setPromoCodeError] = useState(undefined)

  useEffect(() => {
    axios.get('/cms/regions').then(res => {
      setcountrylist(res.data)
    })

    setSiteCountry(window.location.hostname.includes('.nz') ? 'nz' : 'au')
  }, [])

  const [formStatus, setFormStatus] = useState(null)

  const trackBtnClick = () => {
    let src =
      '//pixel.quantserve.com/pixel/p-u64L5wy1qy35w.gif?labels=_fp.event.Thrifty Blue Chip Become a Member Submit Button Click'
    if (siteCountry === 'au') {
      src =
        '//pixel.quantserve.com/pixel/p-qK8G7WdP60WA4.gif?labels=_fp.event.Thrifty Blue Chip Become a Member Submit Button Click AU'
    }

    let imgTag = document.createElement('img')
    imgTag.src = src
    document.body.appendChild(imgTag)
  }

  const submitForm = () => {
    setFormStatus(null)
    let error = false
    setformerror([])
    setmobileError(undefined)
    setmarketingemailError(undefined)
    settermsandconditionsError(undefined)
    setnameError(undefined)
    setmiddlenameError(undefined)
    setlastnameError(undefined)
    setdobError(undefined)
    setaddressoneError(undefined)
    setaddresstwoError(undefined)
    setcityError(undefined)
    setpostcodeError(undefined)
    setstateError(undefined)
    setcountryError(undefined)
    setbillingaddressoneError(undefined)
    setbillingaddresstwoError(undefined)
    setbillingcityError(undefined)
    setbillingpostcodeError(undefined)
    setbillingstateError(undefined)
    setbillingcountriesError(undefined)
    sethomephoneError(undefined)
    setemailError(undefined)
    setconfirmemailError(undefined)
    setdriverlicenselocError(undefined)
    setdriverlicensenumError(undefined)
    setexpdateError(undefined)
    setPromoCodeError(undefined)

    // -- tracking code
    trackBtnClick()
    // -- tracking code

    if (isEmpty(name) && rest.disablename === '0') {
      setnameError(['Please enter your first name'])
      gtm.formErrorDisplay('bluechip', 'Please enter your first name')
      error = true
    }
    if (isEmpty(lastname) && rest.disablelastname === '0') {
      setlastnameError(['Please enter your last name'])
      gtm.formErrorDisplay('bluechip', 'Please enter your last name')
      error = true
    }
    if (isEmpty(dob) && rest.disabledob === '0') {
      setdobError(['Please enter your date of birth'])
      gtm.formErrorDisplay('bluechip', 'Please enter your date of birth')
      error = true
    }
    if (isEmpty(addressone) && rest.disableaddressone === '0') {
      setaddressoneError(['Please enter your street address'])
      gtm.formErrorDisplay('bluechip', 'Please enter your street address')
      error = true
    }
    if (isEmpty(city) && rest.disablecity === '0') {
      setcityError(['Please enter your city'])
      gtm.formErrorDisplay('bluechip', 'Please enter your city')
      error = true
    }
    if (isEmpty(postcode) && rest.disablepostcode === '0') {
      setpostcodeError(['Please enter your postcode'])
      gtm.formErrorDisplay('bluechip', 'Please enter your postcode')
      error = true
    }
    if (isEmpty(state) && siteCountry === 'au' && rest.disablestate === '0') {
      setstateError(['Please enter your region/state'])
      gtm.formErrorDisplay('bluechip', 'Please enter your region/state')
      error = true
    }
    if (isEmpty(country) && rest.disablecountry === '0') {
      setcountryError(['Please select your country'])
      gtm.formErrorDisplay('bluechip', 'Please select your country')
      error = true
    }
    if (!sameas) {
      if (isEmpty(billingaddressone) && rest.disablebillingaddressone === '0') {
        setbillingaddressoneError(['Please enter your street address'])
        gtm.formErrorDisplay('bluechip', 'Please enter your street address')
        error = true
      }
      if (isEmpty(billingcity) && rest.disablebillingcity === '0') {
        setbillingcityError(['Please enter your city'])
        gtm.formErrorDisplay('bluechip', 'Please enter your city')
        error = true
      }
      if (isEmpty(billingpostcode) && rest.disablebillingpostcode === '0') {
        setbillingpostcodeError(['Please enter your postcode'])
        gtm.formErrorDisplay('bluechip', 'Please enter your postcode')
        error = true
      }
      if (isEmpty(billingstate) && siteCountry === 'au' && rest.disablebillingstate === '0') {
        setbillingstateError(['Please enter your region/state'])
        gtm.formErrorDisplay('bluechip', 'Please enter your region/state')
        error = true
      }
      if (isEmpty(billingcountries) && rest.disablebillingcountries === '0') {
        setbillingcountriesError(['Please select your country'])
        gtm.formErrorDisplay('bluechip', 'Please select your country')
        error = true
      }
    }
    if (isEmpty(homephone) && rest.disablehomephone === '0') {
      sethomephoneError(['Please enter your home phone'])
      gtm.formErrorDisplay('bluechip', 'Please enter your home phone')
      error = true
    }
    if (isEmpty(mobile) && rest.disablemobile === '0') {
      setmobileError(['Please enter your mobile'])
      gtm.formErrorDisplay('bluechip', 'Please enter your mobile')
      error = true
    }
    if (isEmpty(driverlicenseloc) && siteCountry === 'au' && rest.disabledriverlicenseloc === '0') {
      setdriverlicenselocError(['Please enter your driver license location'])
      gtm.formErrorDisplay('bluechip', 'Please enter your driver license location')
      error = true
    }
    if (isEmpty(driverlicensenum) && rest.disabledriverlicensenum === '0') {
      setdriverlicensenumError(['Please enter your driver license number'])
      gtm.formErrorDisplay('bluechip', 'Please enter your driver license number')
      error = true
    }
    if (isEmpty(expdate) && rest.disableexpdate === '0') {
      setexpdateError(['Please enter your driver license expiration date'])
      gtm.formErrorDisplay('bluechip', 'Please enter your driver license expiration date')
      error = true
    }

    if (!isEmail(email) && rest.disableemail === '0') {
      setemailError(['Please enter a valid email address'])
      gtm.formErrorDisplay('bluechip', 'Please enter a valid email address')
      error = true
    }
    if (!isEmail(confirmemail) && rest.disableconfirmemail === '0') {
      setconfirmemailError(['Please enter a valid email address'])
      gtm.formErrorDisplay('bluechip', 'Please enter a valid email address')
      error = true
    }
    if (email !== confirmemail && rest.disableconfirmemail === '0') {
      setconfirmemailError(['Your emails do not match.'])
      gtm.formErrorDisplay('bluechip', 'Your emails do not match.')
      error = true
    }

    if (!termsandconditions) {
      settermsandconditionsError(['You must agree to the terms and conditions'])
      gtm.formErrorDisplay('bluechip', 'You must agree to the terms and conditions')
      error = true
    }

    if (!error) {
      setFormSubmitting.true()
      const params = new URLSearchParams()
      if (rest.disablemarketingemail === '0') params.append('marketingemail', marketingemail)
      if (rest.disablename === '0') params.append('name', name)
      if (rest.disablemiddlename === '0') params.append('middlename', middlename)
      if (rest.disablelastname === '0') params.append('lastname', lastname)
      if (rest.disabledob === '0') params.append('dob', dob)
      if (rest.disableaddressone === '0') params.append('addressone', addressone)
      if (rest.disableaddresstwo === '0') params.append('addresstwo', addresstwo)
      if (rest.disablecity === '0') params.append('city', city)
      if (rest.disablepostcode === '0') params.append('postcode', postcode)
      if (rest.disablestate === '0') params.append('state', state)
      if (rest.disablecountry === '0') params.append('country', country)

      if (sameas) {
        if (rest.disablesameas === '0') params.append('sameas', sameas)
      } else {
        if (rest.disablebillingaddressone === '0')
          params.append('billingaddressone', billingaddressone)
        if (rest.disablebillingaddresstwo === '0')
          params.append('billingaddresstwo', billingaddresstwo)
        if (rest.disablebillingcity === '0') params.append('billingcity', billingcity)
        if (rest.disablebillingpostcode === '0') params.append('billingpostcode', billingpostcode)
        if (rest.disablebillingstate === '0') params.append('billingstate', billingstate)
        if (rest.disablebillingcountries === '0')
          params.append('billingcountries', billingcountries)
      }
      if (rest.disablehomephone === '0') params.append('homephone', homephone)
      if (rest.disablemobile === '0') params.append('mobile', mobile)
      if (rest.disableemail === '0') params.append('email', email)
      if (rest.disabledriverlicenseloc === '0') params.append('driverlicenseloc', driverlicenseloc)
      if (rest.disabledriverlicensenum === '0') params.append('driverlicensenum', driverlicensenum)
      if (rest.disableexpdate === '0') params.append('expdate', expdate)

      axios
        .post('/api/bluechip', params)
        .then(({ data }) => {
          setFormSubmitting.false()
          const parsedXml = parseXml(data.result.original)
          const { AddCustomerResponse } = parsedXml['soap:Envelope']['soap:Body']

          if (AddCustomerResponse.hasOwnProperty('Success')) {
            setFormStatus(true)
            setMembershipNumber(AddCustomerResponse.Customer.Profile.LoyaltyMembership.MemberNum)

            setTimeout(() => {
              formMessages.current.scrollIntoView()
            }, 100)

            // Fire email subscription
            const country = window.location.host.includes('.com.au') === true ? 'au' : 'nz'

            const esubParams = new URLSearchParams()
            esubParams.append('email', email)
            esubParams.append(
              'loyaltynumber',
              AddCustomerResponse.Customer.Profile.LoyaltyMembership.MemberNum,
            )
            esubParams.append('firstName', name)
            esubParams.append('brand', 'thrifty')
            esubParams.append('culture', country === 'au' ? 'en-AU' : 'en-NZ')
            if (rest.disablePromoCode === '0' && promoCode != '') {
              esubParams.append('seg', promoCode)
            } else {
              esubParams.append('seg', 'EDM_signup')
            }
            // If marketing email is checked, opted out = false, otherwise true
            esubParams.append('hasOptedOutOfEmail', marketingemail ? false : true)
            esubParams.append('sourceCode', 'BCEnrolment')
            esubParams.append('sourceSystem', country === 'au' ? 'thrifty.com.au' : 'thrifty.co.nz')

            axios.post('/esub', esubParams).catch(err => {
              console.error(err)
            })
          } else if (AddCustomerResponse.hasOwnProperty('Failure')) {
            setTimeout(() => {
              formMessages.current.scrollIntoView()
            }, 100)

            if (AddCustomerResponse.Failure.Error.Message.hasOwnProperty('errorText')) {
              setformerror(
                Array.isArray(AddCustomerResponse.Failure.Error.Message.errorText)
                  ? AddCustomerResponse.Failure.Error.Message.errorText.map(error => error['#text'])
                  : [AddCustomerResponse.Failure.Error.Message.errorText['#text']],
              )
            } else if (Array.isArray(AddCustomerResponse.Failure.Error.Message)) {
              setTimeout(() => {
                formMessages.current.scrollIntoView()
              }, 100)
              setformerror(
                AddCustomerResponse.Failure.Error.Message.map(message => message['#text']),
              )
            } else {
              setformerror([AddCustomerResponse.Failure.Error.Message['#text']])
            }
          } else {
            setTimeout(() => {
              formMessages.current.scrollIntoView()
            }, 100)
            setformerror(['Something went wrong. Please try again later.'])
          }
        })
        .catch(err => {
          console.error(err)
        })
    }
  }

  const useStyles = createUseStyles(theme => ({
    container: {
      padding: '30px 15px',
      '@media (max-width: 700px)': {
        boxSizing: 'border-box',
        padding: '30px 15px',
      },
    },
    innerCont: { margin: '0 auto', width: '100%', maxWidth: '1220px' },
    title: {
      fontSize: '18px',
      lineHeight: '22px',
      fontWeight: 700,
      fontFamily: 'TTRounds',
      textAlign: 'left',
      marginBottom: '15px',
      marginTop: 0,
      color: theme.colors.main,
    },
    details: {
      fontSize: '18px',
      lineHeight: '26px',
      fontWeight: 400,
      textAlign: 'left',
      marginBottom: '30px',
      marginTop: 0,
      maxWidth: centerIt ? '700px' : '560px',
      color: '#000',
      textAlign: centerIt ? 'center' : 'left',
      '@media (max-width: 600px)': {
        fontSize: '15px',
        lineHeight: 1.4,
      },
    },
    flexCont: {
      display: 'grid',
      gridTemplateColumns: '1fr 1fr',
      gap: 20,
      '@media (max-width: 600px)': {
        gridTemplateColumns: '1fr',
        gap: 0,
      },
    },
    flexContFull: {
      display: 'grid',
      gridTemplateColumns: '1fr',
      gap: 20,
    },
    formsec: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'flex-start',
      '@media (max-width: 600px)': {
        flexDirection: 'column',
      },
    },
    formarea: {
      margin: centerIt ? '0 auto' : undefined,
      width: '100%',
      maxWidth: 700,
    },
    tollarea: {
      width: 380,
      borderRadius: 20,
      backgroundColor: '#F5F5F5',
      padding: 40,
      boxSizing: 'border-box',
      '@media (max-width: 600px)': {
        width: '100%',
        marginTop: 60,
      },
    },
    tollareaTitle: {
      color: theme.colors.main,
      fontSize: 18,
      lineHeight: 1.3,
      marginBottom: 20,
    },
    tollareaNumber: {
      color: '#2D2D2D',
      fontSize: 15,
      lineHeight: 1.3,
      marginBottom: 10,
      '& a': {
        color: theme.colors.main,
      },
      '& span': {
        '&:nth-child(2)': {
          marginLeft: 3,
        },
      },
    },
    buttonPrimary: {
      display: 'inline-block',
      padding: '14px 0',
      border: 'none',
      color: '#fff',
      backgroundColor: theme.colors.orange,
      borderRadius: '15px',
      lineHeight: '18px',
      fontSize: '18px',
      fontWeight: 700,
      textDecoration: 'none',
      width: 215,
      '@media (max-width: 600px)': {
        display: 'block',
        width: '100%',
      },
      '&:hover': {
        backgroundColor: theme.colors.orangeHover,
        cursor: 'pointer',
      },
      '&:disabled, &[disabled]': {
        backgroundColor: '#cccccc',
        borderColor: '#cccccc',
        color: '#666666',
      },
    },
  }))

  const classes = useStyles()
  const formMessages = useRef(null)

  return (
    <div className={classes.container}>
      <div className={classes.innerCont}>
        <div className={classes.formsec}>
          <div className={classes.formarea}>
            <div ref={formMessages}></div>
            {formStatus === true && (
              <div
                style={{
                  border: '1px solid #F7F7F7',
                  boxShadow: '1px 5px 15px rgba(0, 0, 0, 0.15)',
                  borderRadius: 20,
                  padding: '50px 25px',
                  margin: '25px 0',
                }}
              >
                <div style={{ fontSize: '20px', lineHeight: 1.3, textAlign: 'center' }}>
                  Thank you for joining the Blue Chip Member Program, your membership number is
                  <br />
                  <div style={{ fontWeight: 'bold', paddingTop: 20, fontSize: 24 }}>
                    {membershipNumber}
                  </div>
                </div>
                <div style={{ textAlign: 'center', paddingTop: 40 }}>
                  <div
                    style={{
                      backgroundColor: '#11BA22',
                      color: '#fff',
                      borderRadius: '18px',
                      padding: '18px 40px',
                      display: 'inline-flex',
                      alignItems: 'center',
                    }}
                  >
                    <SVG
                      name="TickCircle"
                      width={16}
                      height={16}
                      colorOne="#11BA22"
                      colorTwo="#fff"
                    />
                    <span style={{ display: 'inline-block', paddingLeft: 5 }}>Success</span>
                  </div>
                </div>
              </div>
            )}
            {body !== '' && <div className={classes.details}>{body}</div>}
            <div className={classes.form}>
              <>
                {formerror.length > 0 && (
                  <div style={{ fontSize: 14, color: 'red', marginBottom: 20 }}>
                    <b>Something went wrong..</b>
                    <ul>
                      {formerror.map((error, i) => {
                        if (error.trim() === '') return null
                        return <li key={i}>{error}</li>
                      })}
                    </ul>
                  </div>
                )}

                <h3>Personal information</h3>
                <div className={classes.flexCont}>
                  {rest.disablename === '0' && (
                    <div>
                      <FormInput
                        greyBackground={true}
                        disabled={formSubmitting}
                        error={nameError}
                        labelText="First Name*"
                        inputType="text"
                        defaultValue=""
                        onChange={el => {
                          setname(el.currentTarget.value)
                        }}
                      />
                    </div>
                  )}
                  {rest.disablemiddlename === '0' && (
                    <div>
                      <FormInput
                        greyBackground={true}
                        disabled={formSubmitting}
                        error={middlenameError}
                        labelText="Middle name"
                        inputType="text"
                        defaultValue=""
                        onChange={el => {
                          setmiddlename(el.currentTarget.value)
                        }}
                      />
                    </div>
                  )}
                </div>
                <div className={classes.flexCont}>
                  {rest.disablelastname === '0' && (
                    <div>
                      <FormInput
                        greyBackground={true}
                        disabled={formSubmitting}
                        error={lastnameError}
                        labelText="Last name*"
                        inputType="text"
                        defaultValue=""
                        onChange={el => {
                          setlastname(el.currentTarget.value)
                        }}
                      />
                    </div>
                  )}

                  {rest.disabledob === '0' && (
                    <div>
                      <FormInput
                        greyBackground={true}
                        disabled={formSubmitting}
                        error={dobError}
                        labelText="Date of birth*"
                        inputType="masked"
                        maskType="date"
                        defaultValue=""
                        onChange={el => {
                          setdob(el.currentTarget.value)
                        }}
                      />
                    </div>
                  )}
                </div>

                <h3>Your address</h3>
                {rest.disableaddressone === '0' && (
                  <div className={classes.flexContFull}>
                    <FormInput
                      greyBackground={true}
                      disabled={formSubmitting}
                      error={addressoneError}
                      labelText="Address 1*"
                      inputType="text"
                      defaultValue=""
                      onChange={el => {
                        setaddressone(el.currentTarget.value)
                      }}
                    />
                  </div>
                )}
                {rest.disableaddresstwo === '0' && (
                  <div className={classes.flexContFull}>
                    <FormInput
                      greyBackground={true}
                      disabled={formSubmitting}
                      error={addresstwoError}
                      labelText="Address 2"
                      inputType="text"
                      defaultValue=""
                      onChange={el => {
                        setaddresstwo(el.currentTarget.value)
                      }}
                    />
                  </div>
                )}

                <div className={classes.flexCont}>
                  {rest.disablecity === '0' && (
                    <div>
                      <FormInput
                        greyBackground={true}
                        disabled={formSubmitting}
                        error={cityError}
                        labelText="City*"
                        inputType="text"
                        defaultValue=""
                        onChange={el => {
                          setcity(el.currentTarget.value)
                        }}
                      />
                    </div>
                  )}

                  {rest.disablepostcode === '0' && (
                    <div>
                      <FormInput
                        greyBackground={true}
                        disabled={formSubmitting}
                        error={postcodeError}
                        labelText="Postcode*"
                        inputType="text"
                        defaultValue=""
                        onChange={el => {
                          setpostcode(el.currentTarget.value)
                        }}
                      />
                    </div>
                  )}
                </div>

                {siteCountry === 'au' ? (
                  <div className={classes.flexCont}>
                    {rest.disablestate === '0' && (
                      <div>
                        <FormSelect
                          noSearch
                          greyBackground
                          placeholder="State"
                          labelText="State"
                          defaultValue={state}
                          optionsArray={['ACT', 'NSW', 'NT', 'QLD', 'SA', 'TAS', 'VIC', 'WA'].map(
                            type => ({
                              value: type,
                              label: type,
                            }),
                          )}
                          error={stateError}
                          onChange={el => {
                            setstate(el.target.value)
                          }}
                        />
                      </div>
                    )}

                    {rest.disablecountry === '0' && (
                      <div>
                        <FormSelect
                          noSearch
                          greyBackground
                          placeholder="Country"
                          labelText="Country"
                          optionsArray={countrylist}
                          defaultValue={country}
                          error={countryError}
                          onChange={el => {
                            setcountry(el.target.value)
                          }}
                        />
                      </div>
                    )}
                  </div>
                ) : (
                  rest.disablecountry === '0' && (
                    <div>
                      <FormSelect
                        noSearch
                        greyBackground
                        placeholder="Country"
                        labelText="Country"
                        optionsArray={countrylist}
                        defaultValue={country}
                        error={countryError}
                        onChange={el => {
                          setcountry(el.target.value)
                        }}
                      />
                    </div>
                  )
                )}

                <h3>Billing address</h3>
                {rest.disablesameas === '0' && (
                  <div className={classes.flexContFull}>
                    <div>
                      <FormCheckbox
                        labelText="Tick if the same as street address"
                        inputName=""
                        defaultValue={false}
                        onChange={setsameas.toggle}
                      />
                    </div>
                  </div>
                )}

                {!sameas && (
                  <>
                    {rest.disablebillingaddressone === '0' && (
                      <div className={classes.flexContFull}>
                        <FormInput
                          greyBackground={true}
                          disabled={formSubmitting}
                          error={billingaddressoneError}
                          labelText="Address*"
                          inputType="text"
                          defaultValue=""
                          onChange={el => {
                            setbillingaddressone(el.currentTarget.value)
                          }}
                        />
                      </div>
                    )}
                    {rest.disablebillingaddresstwo === '0' && (
                      <div className={classes.flexContFull}>
                        <FormInput
                          greyBackground={true}
                          disabled={formSubmitting}
                          error={billingaddresstwoError}
                          labelText="Address 2"
                          inputType="text"
                          defaultValue=""
                          onChange={el => {
                            setbillingaddresstwo(el.currentTarget.value)
                          }}
                        />
                      </div>
                    )}
                    <div className={classes.flexCont}>
                      {rest.disablebillingcity === '0' && (
                        <div>
                          <FormInput
                            greyBackground={true}
                            disabled={formSubmitting}
                            error={billingcityError}
                            labelText="City*"
                            inputType="text"
                            defaultValue=""
                            onChange={el => {
                              setbillingcity(el.currentTarget.value)
                            }}
                          />
                        </div>
                      )}

                      {rest.disablebillingpostcode === '0' && (
                        <div>
                          <FormInput
                            greyBackground={true}
                            disabled={formSubmitting}
                            error={billingpostcodeError}
                            labelText="Postcode*"
                            inputType="text"
                            defaultValue=""
                            onChange={el => {
                              setbillingpostcode(el.currentTarget.value)
                            }}
                          />
                        </div>
                      )}
                    </div>

                    {siteCountry === 'au' ? (
                      <div className={classes.flexCont}>
                        {rest.disablebillingstate === '0' && (
                          <div>
                            <FormSelect
                              noSearch
                              greyBackground
                              placeholder="State"
                              labelText="State"
                              defaultValue={billingstate}
                              optionsArray={[
                                'ACT',
                                'NSW',
                                'NT',
                                'QLD',
                                'SA',
                                'TAS',
                                'VIC',
                                'WA',
                              ].map(type => ({
                                value: type,
                                label: type,
                              }))}
                              error={billingstateError}
                              onChange={el => {
                                setbillingstate(el.target.value)
                              }}
                            />
                          </div>
                        )}

                        {rest.disablebillingcountries === '0' && (
                          <div>
                            <FormSelect
                              noSearch
                              greyBackground
                              placeholder="Country"
                              labelText="Country"
                              defaultValue={billingcountries}
                              optionsArray={countrylist}
                              error={billingcountriesError}
                              onChange={el => {
                                setbillingcountries(el.target.value)
                              }}
                            />
                          </div>
                        )}
                      </div>
                    ) : (
                      rest.disablebillingcountries === '0' && (
                        <div>
                          <FormSelect
                            noSearch
                            greyBackground
                            placeholder="Country"
                            labelText="Country"
                            defaultValue={billingcountries}
                            optionsArray={countrylist}
                            error={billingcountriesError}
                            onChange={el => {
                              setbillingcountries(el.target.value)
                            }}
                          />
                        </div>
                      )
                    )}
                  </>
                )}

                <h3>Contact details</h3>
                <div className={classes.flexCont}>
                  {rest.disablehomephone === '0' && (
                    <div>
                      <FormInput
                        greyBackground={true}
                        disabled={formSubmitting}
                        error={homephoneError}
                        labelText="Home phone*"
                        inputType="text"
                        defaultValue=""
                        onChange={el => {
                          sethomephone(el.currentTarget.value)
                        }}
                      />
                    </div>
                  )}
                  {rest.disablemobile === '0' && (
                    <div>
                      <FormInput
                        greyBackground={true}
                        disabled={formSubmitting}
                        error={mobileError}
                        labelText="Mobile phone*"
                        inputType="text"
                        defaultValue=""
                        onChange={el => {
                          setmobile(el.currentTarget.value)
                        }}
                      />
                    </div>
                  )}
                </div>
                <div className={classes.flexCont}>
                  {rest.disableemail === '0' && (
                    <div>
                      <FormInput
                        greyBackground={true}
                        disabled={formSubmitting}
                        error={emailError}
                        labelText="Email address*"
                        inputType="text"
                        defaultValue=""
                        onChange={el => {
                          setemail(el.currentTarget.value)
                        }}
                      />
                    </div>
                  )}
                  {rest.disableconfirmemail === '0' && (
                    <div>
                      <FormInput
                        greyBackground={true}
                        disabled={formSubmitting}
                        error={confirmemailError}
                        labelText="Re-enter email*"
                        inputType="text"
                        defaultValue=""
                        onChange={el => {
                          setconfirmemail(el.currentTarget.value)
                        }}
                      />
                    </div>
                  )}
                </div>

                <h3>Rental information</h3>
                <div className={classes.flexCont}>
                  {siteCountry === 'au'
                    ? rest.disabledriverlicenseloc === '0' && (
                        <div>
                          <FormSelect
                            noSearch
                            greyBackground
                            placeholder="Driver License Location"
                            labelText="Driver License Location"
                            defaultValue={driverlicenseloc}
                            optionsArray={['ACT', 'NSW', 'NT', 'QLD', 'SA', 'TAS', 'VIC', 'WA'].map(
                              type => ({
                                value: type,
                                label: type,
                              }),
                            )}
                            error={driverlicenselocError}
                            onChange={el => {
                              setdriverlicenseloc(el.target.value)
                            }}
                          />
                        </div>
                      )
                    : rest.disabledriverlicensenum === '0' && (
                        <div>
                          <FormInput
                            greyBackground={true}
                            disabled={formSubmitting}
                            error={driverlicensenumError}
                            labelText="Driver License Number*"
                            inputType="text"
                            defaultValue=""
                            onChange={el => {
                              setdriverlicensenum(el.currentTarget.value)
                            }}
                          />
                        </div>
                      )}
                  {siteCountry === 'au'
                    ? rest.disabledriverlicensenum === '0' && (
                        <div>
                          <FormInput
                            greyBackground={true}
                            disabled={formSubmitting}
                            error={driverlicensenumError}
                            labelText="Driver License Number*"
                            inputType="text"
                            defaultValue=""
                            onChange={el => {
                              setdriverlicensenum(el.currentTarget.value)
                            }}
                          />
                        </div>
                      )
                    : rest.disableexpdate === '0' && (
                        <div>
                          <FormInput
                            greyBackground={true}
                            disabled={formSubmitting}
                            error={expdateError}
                            labelText="Expiration date*"
                            inputType="masked"
                            maskType="date"
                            defaultValue=""
                            onChange={el => {
                              setexpdate(el.currentTarget.value)
                            }}
                          />
                        </div>
                      )}
                </div>

                {rest.disableexpdate === '0' && siteCountry === 'au' ? (
                  <div className={classes.flexCont}>
                    <div>
                      <FormInput
                        greyBackground={true}
                        disabled={formSubmitting}
                        error={expdateError}
                        labelText="Expiration date*"
                        inputType="masked"
                        maskType="date"
                        defaultValue=""
                        onChange={el => {
                          setexpdate(el.currentTarget.value)
                        }}
                      />
                    </div>
                  </div>
                ) : null}

                {rest.disablePromoCode === '0' && (
                  <>
                    <h3>Promo code</h3>
                    <div className={classes.flexCont}>
                      <div>
                        <FormInput
                          greyBackground={true}
                          disabled={formSubmitting}
                          labelText="Enter Promo Code"
                          inputType="text"
                          defaultValue=""
                          onChange={el => {
                            setPromoCode(el.currentTarget.value)
                          }}
                        />
                      </div>
                    </div>
                  </>
                )}

                {rest.disablemarketingemail === '0' && (
                  <div className={classes.flexContFull}>
                    <div>
                      <FormCheckbox
                        labelText="By selecting this checkbox you are indicating that you would like to periodically receive marketing and promotional materials via email from Thrifty. You can withdraw your consent to receive marketing and promotional materials at any time either by using the unsubscribe link found in those electronic messages."
                        inputName=""
                        defaultValue={false}
                        error={marketingemailError}
                        onChange={setmarketingemail.toggle}
                      />
                    </div>
                  </div>
                )}

                <div className={classes.flexContFull}>
                  <div>
                    <FormCheckbox
                      labelText={
                        <>
                          I have read and agree to the Blue Chip{' '}
                          <a href="/blue-chip-terms-and-conditions" target="_blank">
                            Terms and Conditions
                          </a>
                          {rest.promoTermsContiditionsLink &&
                            rest.promoTermsContiditionsLink !== '' && (
                              <span>
                                {' '}
                                and the promotion{' '}
                                <a href={rest.promoTermsContiditionsLink} target="_blank">
                                  Terms and Conditions
                                </a>
                              </span>
                            )}
                          .
                        </>
                      }
                      inputName=""
                      defaultValue={false}
                      error={termsandconditionsError}
                      onChange={settermsandconditions.toggle}
                    />
                  </div>
                </div>

                <div className={classes.flexContFull}>
                  <div style={{ paddingTop: 20 }}>
                    <button
                      disabled={formSubmitting}
                      onClick={submitForm}
                      className={classes.buttonPrimary}
                    >
                      {formSubmitting ? 'processing...' : 'Submit'}
                    </button>
                  </div>
                </div>
              </>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default BlueChipForm
